<template>
  <BaseTemplate>
    <div class="purchase-class">
      <Title class="_title" :jpn="t('Xmarket出品リスト')" />
      <div class="search-container">
        <div class="search-bar">
          <input type="text" v-model="postParam.freeword" @change="search(1)" />
          <button class="search-button">
            🔍
          </button>
        </div>
      </div>
      <MarketNotice />
      <MarketHeader
        :selectType="selectType"
        @changeSaleType="changeSaleType"
        @changeCardType="changeCardType"
      />
      <!-- <p>{{ cardList }}</p> -->
      <div class="card-list">
        <MarketCardList
          v-if="cardList"
          :isMyList="true"
          :cardList="cardList.list"
          :cardListTitle="t('検索結果')"
          :currentUser="currentUser"
        />
        <BoxPager
        v-if="cardList.page && cardList.page.pages && cardList.page.pages.length > 1"
        class="box-pager"
        :totalPageCount="cardList.page.all_page"
        :currentPageCount="cardList.page.page"
        :dispBoxCount="cardList.page.pages.length"
        :pages="cardList.page.pages"
        @handlePagerClick="changeCurrentPageCount"
        @handleSquareBtnClick="changeCurrentPageCount"
      />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import MarketCardList from '@/components/organisms/MarketCardList.vue';
import Title from '@/components/molecules/Title02.vue';
import MarketHeader from '@/components/molecules/Header/MarketMyListHeader.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import MarketNotice from '@/components/atoms/MarketNotice.vue';

export default {
  name: 'Market',
  mixins: [t],
  components: {
    BaseTemplate,
    Title,
    MarketCardList,
    BoxPager,
    MarketHeader,
    MarketNotice,
  },
  data() {
    return {
      errorMessage: {},
      showCardDetail: false,
      popupCardData: {},
      pageNumber: 1,
      postParam: {
        freeword: '',
        type: 2,
        sale_type: 0,
        card_type: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      marketList: 'market/resultMarketMyList',
      selectType: 'cardType/cardTypeList',
      currentUser: 'user/currentUserDetail',
      myListCardType: 'market/myListCardType',
    }),
    cardList() {
      if (this.marketList) {
        return this.marketList;
      }
      return [];
    },
  },
  created() {
    // storeからcard_typeを取得して設定
    if (this.myListCardType) {
      this.postParam.card_type = this.myListCardType;
    }
    this.$store.dispatch('market/my_list', {
      pageNumber: this.pageNumber,
      postParam: this.postParam,
    });
    this.$store.dispatch('cardType/setCardTypeList');
  },
  methods: {
    changeCurrentPageCount(page) {
      this.page = page;
      this.search(page);
    },
    changeSaleType(mode) {
      this.postParam.sale_type = mode;
      this.search();
    },
    changeCardType(mode) {
      this.postParam.card_type = mode;
      this.search();
    },
    search() {
      this.$store.dispatch('market/my_list', {
        pageNumber: this.pageNumber,
        postParam: this.postParam,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-class{
  width: 100%;
  min-height: 100vh;
  margin: 0 auto ;
  color: #042859;
  ._title {
    margin-top: 20px;
    max-width: 900px;
    margin: 0 auto;
  }
  //検索バーとフィルター___________________
  .search-container {
    max-width: 900px;
    // background-color: #f0f0f0;
    margin: 0 auto;
    width: 90%;
    padding: 20px 20px 10px 20px;
    text-align: center;
    .search-bar {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      padding: 5px 10px;
      position: relative;
      border: 1px solid $gray2;
      input {
        flex-grow: 1;
        border: none;
        outline: none;
        font-size: 16px;
      }
      .search-button {
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
//カード一覧_____________________________
  .card-container {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 15px;
    padding: 20px;
  }
  // フッターメニュー
  .footer-menu {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    width: 90%;
    position: fixed;
    bottom: 97px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    z-index: 1000;
    @media screen and (max-width: $tabletWidth) {
      bottom: 66px;
      gap: 2px;
      width: 97%;
    }
    .menu-button-left,.menu-button-right {
      flex: 1;
      text-align: center;
      font-weight: bold;
      padding: 10px;
      font-size: 18px;
      border: none;
      cursor: pointer;
      outline: none;
      transition: all 0.3s ease-in-out;
      border-radius: 10px;
      box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: $tabletWidth) {
        padding: 4px;
      }
    }
  .menu-button-left {
    color: white;
    background: linear-gradient(to bottom, #3fcdff, #1085d0); // 青色グラデーション
    &:hover {
      background: linear-gradient(to bottom, #49a8ff, #0d75bb);
    }
  }
  .menu-button-right {
    color: #323232;
    background: linear-gradient(to bottom, #fff100, #ff9800); // 黄色グラデーション
    &:hover {
      background: linear-gradient(to bottom, #ffd04a, #ff8f00);
    }
  }
}
  .overlay_conf{
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .market-modal {
      border: none;
      box-shadow:  0 0px 20px rgba(0, 0, 0, 1.0);
      border-radius: 10px;
      max-width: 700px;
      max-height: 90%;
      overflow-y: auto;
      padding: 20px;
      position: relative;
      width: 100%;
      @media screen and (max-width: $tabletWidth) {
        max-width: 530px;
      }
      .block {
        padding: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin: 5px 20px;
        font-weight: bold;
        text-align: center;
      }
      .complete-container {
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .complete-message {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin-bottom: 20px;
        }
        .button-group {
          display: flex;
          justify-content: center;
          margin-top: 20px;
          .close-button {
            padding: 10px 60px;
            background: #a1a2a2;
            color: white;
            font-size: 16px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          }
        }
      }
    }
  }
}
</style>
